import { ReactElement } from 'react';
import styles from '../../../../windows-updates/grid/cell-renderers/UpdateStatusCells.module.scss';
import Spinner from '../../spinner/Spinner';
import {
  PlayCircleFilledIcon,
  AttentionFilledIcon,
  CheckmarkCircleFilledIcon,
  ClockOutlinedIcon,
  CloseCircleFilledIcon,
  BlockOutlinedIcon,
  CalendarOutlinedIcon
} from '@getgo/chameleon-icons/react';
import { Typography } from '@getgo/chameleon-web-react-wrapper/register';
import { useTranslation } from 'react-i18next';

export enum InstallationStatus {
  Available = 'Available',
  Downloading = 'Downloading',
  Downloaded = 'Downloaded',
  DownloadingFailed = 'DownloadingFailed',
  Installing = 'Installing',
  InstallingFailed = 'InstallingFailed',
  RestartRequired = 'RestartRequired',
  Installed = 'Installed',
  Pending = 'Pending',
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled'
}

const iconSelector: { [key in keyof typeof InstallationStatus]: ReactElement } = {
  Available: <PlayCircleFilledIcon color={'rgba(27, 135, 86, 1)'} size={'24px'} />,
  Downloading: <PlayCircleFilledIcon color={'rgba(27, 135, 86, 1)'} size={'24px'} />,
  Downloaded: <PlayCircleFilledIcon color={'rgba(27, 135, 86, 1)'} size={'24px'} />,
  DownloadingFailed: <PlayCircleFilledIcon color={'rgba(27, 135, 86, 1)'} size={'24px'} />,
  Installing: <Spinner useGotoColor={true} />,
  InstallingFailed: <CloseCircleFilledIcon size={'24px'} color={'var(--goto-icon-color-danger)'} />,
  RestartRequired: <AttentionFilledIcon color={'rgba(165, 148, 30, 1)'} size={'24px'} />,
  Installed: <CheckmarkCircleFilledIcon color={'rgba(27, 135, 86, 1)'} size={'24px'} />,
  Pending: <ClockOutlinedIcon color={'var(--goto-surface-color-tertiary)'} size={'24px'} />,
  Scheduled: <CalendarOutlinedIcon size={'24px'} color={'var(--goto-icon-color-secondary)'} />,
  Cancelled: <BlockOutlinedIcon size={'24px'} color={'var(--goto-icon-color-disabled)'} />
};

function InstallationStatusCellRenderer({ value }: { value: InstallationStatus }): ReactElement {
  const { t } = useTranslation();
  if (value) {
    const twoLineStatus =
      value === InstallationStatus.Downloaded ||
      value === InstallationStatus.Downloading ||
      value === InstallationStatus.DownloadingFailed ||
      value === InstallationStatus.Pending ||
      value === InstallationStatus.Installing;
    return (
      <div className={styles.cell}>
        {iconSelector[value as InstallationStatus]}
        {twoLineStatus ? (
          <div className={styles.textContainer}>
            <Typography variant="body-small">
              {t(`deviceDetails.grid.windows.installationStatuses.${value}.title`)}
            </Typography>
            <Typography variant="caption-small" color="type-color-secondary">
              {t(`deviceDetails.grid.windows.installationStatuses.${value}.description`)}
            </Typography>
          </div>
        ) : (
          <Typography variant="body-small">{t(`deviceDetails.grid.windows.installationStatuses.${value}`)}</Typography>
        )}
      </div>
    );
  } else {
    return <></>;
  }
}

export default InstallationStatusCellRenderer;
